// Px to nudge the window-centered undo control left so the open panel doesn't cover it (0 if it clears).
const GAP_PX = 16;

type NudgeInput = {
  viewportWidth: number;
  controlWidth: number;
  panelWidth: number;
};

export const undoNudgePx = ({ viewportWidth, controlWidth, panelWidth }: NudgeInput): number => {
  if (panelWidth <= 0) return 0;
  const controlRight = viewportWidth / 2 + controlWidth / 2;
  const panelLeft = viewportWidth - panelWidth;
  return Math.max(0, controlRight + GAP_PX - panelLeft);
};
